/* Okendo `.oke-w-writeReview` - Patch for Accessibility - Start */
(() => {
  const selector = 'a.oke-w-writeReview';

  function fixOkendoWriteReviewLink(root = document) {
    const links = root.matches?.(selector)
      ? [root]
      : Array.from(root.querySelectorAll?.(selector) || []);

    links.forEach((link) => {
      /*
       * Clone the link and remove Okendo's screen-reader-only text
       * so we can retrieve the actual visible button label.
       */
      const clone = link.cloneNode(true);

      clone
        .querySelectorAll('.oke-a11yText, [aria-hidden="true"]')
        .forEach((element) => element.remove());

      const visibleLabel =
        clone.textContent.replace(/\s+/g, ' ').trim() || 'Write a Review';

      const accessibleLabel = `${visibleLabel} (opens in a new window)`;

      if (link.getAttribute('aria-label') !== accessibleLabel) {
        link.setAttribute('aria-label', accessibleLabel);
      }
    });
  }

  fixOkendoWriteReviewLink();

  /*
   * Okendo loads asynchronously, so watch for the widget being added
   * or another script changing its aria-label.
   */
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.target.matches?.(selector)
      ) {
        fixOkendoWriteReviewLink(mutation.target);
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          fixOkendoWriteReviewLink(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });
})();
/* Okendo `.oke-w-writeReview` - Patch for Accessibility - End */

/* Cookie Banner  -Patch for Accessibility - Start
Added a visually hidden “Cookie preferences” heading with the ID expected by Shopify’s native privacy banner when no visible banner title is configured.
This prevents the cookie dialog from referencing a missing ID while preserving the compact, title-free visual design.
*/
(() => {
  const fixShopifyPrivacyBannerTitle = () => {
    const banner = document.getElementById('shopify-pc__banner');

    if (!banner) {
      return false;
    }

    const titleId = 'shopify-pc__banner__body-title';

    if (!document.getElementById(titleId)) {
      const title = document.createElement('span');

      title.id = titleId;
      title.className = 'sr-only';
      title.textContent = 'Cookie preferences';

      const bannerBody =
        banner.querySelector('.shopify-pc__banner__body') || banner;

      bannerBody.prepend(title);
    }

    return true;
  };

  if (fixShopifyPrivacyBannerTitle()) {
    return;
  }

  const observer = new MutationObserver(() => {
    if (fixShopifyPrivacyBannerTitle()) {
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


(function () {
  function labelKlaviyoEmailFields(root = document) {
    const emailFields = root.querySelectorAll(
      'input[type="email"][name="contact[email]"], input[type="email"][id*="contactemail"]'
    );

    emailFields.forEach((field) => {
      if (
        !field.getAttribute('aria-label') &&
        !field.getAttribute('aria-labelledby') &&
        field.labels.length === 0
      ) {
        field.setAttribute(
          'aria-label',
          field.getAttribute('placeholder') || 'E-mail'
        );
      }
    });
  }

  labelKlaviyoEmailFields();

  const observer = new MutationObserver(() => {
    labelKlaviyoEmailFields();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
/* Cookie Banner  -Patch for Accessibility - End */

/* Footer: Klaviyo Email Newsletter Email Submit field - Patch for Accessibility - Start
KLAVIYO EMAIL FIELD ACCESSIBLE NAME Accessibility finding:
plate-113301 Klaviyo may dynamically render or replace email inputs without an associated label,
causing the placeholder to become the field's only accessible name. This script watches for
Klaviyo email fields and adds an aria-label only when the field does not already have an
aria-label, aria-labelledby, or associated <label>.
*/
(function () {
  function labelKlaviyoEmailFields(root = document) {
    const emailFields = root.querySelectorAll(
      'input[type="email"][name="contact[email]"], input[type="email"][id*="contactemail"]'
    );

    emailFields.forEach((field) => {
      if (
        !field.getAttribute('aria-label') &&
        !field.getAttribute('aria-labelledby') &&
        field.labels.length === 0
      ) {
        field.setAttribute(
          'aria-label',
          field.getAttribute('placeholder') || 'E-mail'
        );
      }
    });
  }

  labelKlaviyoEmailFields();

  const observer = new MutationObserver(() => {
    labelKlaviyoEmailFields();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
/* Footer: Klaviyo Email Newsletter Email Submit field - Patch for Accessibility - End */